<template>
  <div class="body">
    <div class="detay">
      <div class="sayfabaslik">
        <div class="text">
          <div class="el-button-group">
            <router-link tag="el-button" class="el-button--small" active-class="el-button--primary"
                         to="/iletisim/sms" type="default"> Kısa Mesaj
            </router-link>
<!--            <router-link tag="el-button" class="el-button&#45;&#45;small is-disabled" disabled="disabled" active-class="el-button&#45;&#45;primary"-->
<!--                         to="/iletisim/mail" type="default"> E-Posta-->
<!--            </router-link>-->
            <router-link tag="el-button" class="el-button--small"  active-class="el-button--primary"
                         to="/iletisim/duyuru" type="default"> Duyuru
            </router-link>
          </div>
        </div>
      </div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
    export default {
        data() {
            return {}
        },
        created() {
            if (this.$store.getters.Yetki.iletisim == '0') this.$router.push("/403");
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Iletisim/_route.vue